import navigation from "@/lang/th/navigation";
import generics from "@/lang/th/generics";
import questions from "@/lang/th/questions";
import a11y from "@/lang/th/a11y";
import velt from "@/lang/th/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}
